<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Love Hearts</h1>
<p class="BOD2">Everyone loves a heart – make a practical pin cushion or send one in a card to a special person on Valentine’s Day. Whatever you do, surround yourself with love!</p>
<p class="IMAGE"><img alt="" src="images/C1-7.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-8.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-4.vue?3293e174